import { useMergeState } from '@/shared/lib/customHooks';
import { useEffect } from 'react';
import type { ProtectPlusDeviceModalProps } from './protectPlusDeviceModal.types';

/**
 * Tracks whether the user has acknowledged the Protect Plus device modal. Holds an isUnderstood
 * flag in merged local state, resets it whenever the modal opens or closes, and exposes a change
 * handler for the acknowledgement checkbox.
 *
 * @param isOpen - Whether the modal is open.
 * @returns An object carrying the modal state and the checkbox change handler.
 */
export const useProtectPlusDeviceModal = ({
  isOpen,
}: Pick<ProtectPlusDeviceModalProps, 'isOpen'>) => {
  const [state, setState] = useMergeState({
    isUnderstood: false,
  });

  /**
   * Records the acknowledgement checkbox of the Protect Plus device modal. Writes the value into the isUnderstood state flag.
   *
   * @param value - New checkbox value.
   * @returns Nothing.
   */
  const onChange = (value: any) => {
    setState({ isUnderstood: value });
  };

  useEffect(() => {
    setState({ isUnderstood: false });
  }, [isOpen]);

  return { state, onChange };
};
